//@ts-ignore
import DynamicCss from "./DynamicCSS/DynamicCss";
import "@fortawesome/fontawesome-free/css/all.css";
import ErrorBoundary from "./Pages/CustomErrorPage/ErrorBoundary";

// import FormDemo from "./FormDemo/FormDemo";
import "./App.css";
import "./theme.css";

import RoutesComponent from "./Routes/routes.tsx";

import { LoaderContext } from "./Helpers/Context/Context";
import Loader from "./Helpers/Loader/Loader";
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [loader, setLoader] = useState<boolean>(false);
  const showLoader = () => setLoader(() => true);
  const hideLoader = () => setLoader(() => false);
  return (
    <ErrorBoundary>
      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        {/* <Header />
        <Sidebar /> */}
        <RoutesComponent />
        <div className="main-container"></div>
        {/* <Footer /> */}
        {loader && <Loader />}
      </LoaderContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
